// extracted by mini-css-extract-plugin
export default {"confirmButton":"modalGeneric_confirmButton__nD+X0","MuiButton-root":"modalGeneric_MuiButton-root__Rt-F0","cancelButton":"modalGeneric_cancelButton__9fD3R"};